import useModalRouter from './useModalRouter';
import { useEffect, useState } from 'react';
import { Modals } from '../../exports/Enums';
import { selectOrderMethod } from '../../../../store/slices/OrderSlice';
import { useSelector } from 'react-redux';
import moment from 'moment';
import useUrlParams from '../../../../hooks/utility/useUrlParams';
import { ORDER_METHODS } from '../../../../services/exports/Constants';
import { useDefaultSlug } from '../selectors/selectors';
import useCompanyBusinessTime from '../../../../hooks/availability/company-business-time/useCompanyBusinessTime';

interface Props {
  enabled?: boolean;
  orderMethod?: ORDER_METHODS;
  scheduledFor?: string;
}

const useRestaurantClosedFallback = ({ enabled, scheduledFor, orderMethod: checkedOrderMethod }: Props) => {
  const { openModal } = useModalRouter();
  const params = useUrlParams();
  const { open_modal } = params;
  const selectedOrderMethod = useSelector(selectOrderMethod);
  const { slug } = useDefaultSlug();
  const orderMethod = checkedOrderMethod ?? selectedOrderMethod;
  const [now] = useState(() => moment());
  const date = scheduledFor ? moment(scheduledFor) : now;
  const { isBusinessTime, isLoading } = useCompanyBusinessTime({
    orderMethod,
  });

  const validate = (): boolean => {
    if (isBusinessTime(date.format())) {
      return true;
    }

    setTimeout(() => openModal({ id: Modals.RestaurantClosed }), 0);
  };

  useEffect(() => {
    if (!enabled || open_modal || !slug || isLoading) {
      return;
    }

    validate();
  }, [isLoading, slug]);

  return { validate };
};

export default useRestaurantClosedFallback;
